module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"allgreen":"異常なし","firmware_version":"ファームウェアのバージョン","ip_address":"ローカルIPアドレス","download":"最新のログをダウンロードする"},"en":{"allgreen":"Normal","firmware_version":"Firmware Version","ip_address":"Local IP Address","download":"Download latest log"}}')
  delete Component.options._Ctor
}
